<template>
  <div class="search-results">
    <template v-if="isLoaded">

      <div v-if="users.length" class="search-results__heading">
        People
      </div>
      <search-result-user
        v-for="user in users"
        :key="user.id"
        type="search"
        :data="user"
      />

      <div v-if="rooms.length" class="search-results__heading">
        Rooms
      </div>
      <search-result-room
        v-for="room in rooms"
        :key="room.id"
        :data="room"
      />

      <div v-if="!rooms.length && !users.length" class="search-results__heading">
        No matches
      </div>
    </template>
    <template v-else>
      <div v-if="!query" class="search-results__heading search-results__heading--status">
        <div class="search-results-placeholder-icon">
          <img class="search-results-placeholder-icon__image" src="@/assets/search-icons/search-placeholder.svg" aria-hidden="true"/>
        </div>
        <template v-if="$route.name != 'room'">
          Start typing to search <br> <b>{{placeholder}}</b>
        </template>
        <template v-else>
          Start typing to invite <br> <b>Space members</b> to Room
        </template>
      </div>
      <template v-else>
        <Skeleton class="search-results__heading" size="40% auto" shimmer rounded-sm>&nbsp;</Skeleton>
        <Skeleton
          v-for="i in skeletons" :key="i"
          size="100% auto" padding="12px 12px 12px 63px" rounded gradient noverflow shadow-light
        >
          <Skeleton size="45px" circle shimmer absolute offsets="10px auto auto 10px"/>
          <Skeleton size="75% 17px" margin="0 0 9px" shimmer rounded-sm/>
          <Skeleton size="60% 12px" margin="4px 0" shimmer rounded-sm/>
          <Skeleton size="40% 12px" margin="4px 0" shimmer rounded-sm/>
          <Skeleton size="50% 16px" margin="9px 0 0" shimmer rounded-sm/>
        </Skeleton>

        <Skeleton class="search-results__heading" size="40% auto" shimmer rounded-sm>&nbsp;</Skeleton>
        <Skeleton
          v-for="i in skeletons" :key="i+2"
          size="100% 80px" padding="12px 12px 12px 95px" rounded gradient noverflow shadow-light
        >
          <Skeleton size="100px" circle shimmer absolute offsets="-12.5px auto auto -20px"/>
          <Skeleton size="75% 17px" shimmer rounded-sm/>
          <Skeleton size="25px 17px" shimmer rounded-sm absolute offsets="auto auto 10px"/>
        </Skeleton>
      </template>
    </template>
    <div v-if="!isLobby && ifOnCurrentUsersRoomPage && isPremiumEnabled" class="search-results__invite-external">
      <button @click="inviteExternalUser" class="search-results__invite-external-button">
        <div>
          <b>Invite to Room</b>
          <p>Invite external guests</p>
        </div>
        <img src="@/assets/settings-icons/invite-user-green.svg" aria-hidden="true"/>
      </button>
    </div>
    <div v-if="$route.name !== 'room' && isOpenSpace" class="search-results__invite-external">
      <button @click="inviteExternalUser" class="search-results__invite-external-button">
        <div>
          <b>Invite to Space</b>
          <p>Invite external guests</p>
        </div>
        <img src="@/assets/settings-icons/invite-user-green.svg" aria-hidden="true"/>
      </button>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from "vuex";
import Skeleton from '@/components/global/loading/Skeleton.vue';
import SearchResultUser from './SearchResultUser.vue'
import SearchResultRoom from './SearchResultRoom.vue'
import InviteExternalGuestsModal from '@/components/modals/admin/InviteExternalGuestsModal.vue';
import InviteExternalSpaceGuestsModal from '@/components/modals/admin/InviteExternalSpaceGuestsModal.vue';

export default {
  components: { SearchResultUser, SearchResultRoom, Skeleton },
  data: () => ({skeletons: 2}),
  computed: {
    ...mapGetters('search', ['placeholder', 'isLoaded', 'query', 'users', 'rooms']),
    ...mapGetters({
      isLobby: 'routing/isLobby',
      isPremiumEnabled: 'getCurrentAreaPremiumFeaturesEnabled',
      isOpenSpace: 'isOpenSpace',
      ifOnCurrentUsersRoomPage: 'getIfOnCurrentUsersRoomPage',
    })
  },
  methods: {
    ...mapActions(['modal/open']),
    inviteExternalUser() {
      if(this.$route.name === 'room') this['modal/open']([InviteExternalGuestsModal])
      else this['modal/open']([InviteExternalSpaceGuestsModal])
    }
  }
};
</script>

<style scoped lang="scss">
.search {
  &-results {
    padding: 10px 20px;
    display: flex;
    flex-flow: column;
    row-gap: 20px;
    overflow-y: auto;
    flex-grow: 1;

    &__heading {
      color: white;
      font-size: 20px;
      font-weight: bold;
      margin: 10px 0 0;

      &--status {
        line-height: 1.3;
        color: $grey-2;
        font-weight: normal;
        text-align: center;

        & b {
          color: white;
        }
      }
    }

    &__invite-external {
      border-top: 2px solid $grey-3;
      margin-top: 10px;
      padding-top: 30px;

      &-button {
        cursor: pointer;
        width: 100%;
        color: white;
        font-size: 0.875rem; /** 14px*/
        background-color: #141313;
        border-radius: 14px;
        padding: 20px 18px;
        display: grid;
        grid-auto-flow: column;
        justify-content: stretch;
        align-items: center;
        border: none;
        gap: 10px;
        transition: background-color 0.2s;

        & > * {
          pointer-events: none;
        }

        & img {
          justify-self: flex-end;
        }

        & div {
          display: flex;
          flex-direction: column;
          gap: 0.2rem;
          text-align: left;

          & p {
            font-size: 0.8rem; /** 14px*/
            color: $grey-2;
          }
        }

        &:hover {
          background-color: $active-user-room;

          & p {
            color: white !important;
          }
          & img {
            filter: brightness(1000%);
          }
        }
        @include mobile-only {
          background-color: $active-user-room;

          & p {
            color: white !important;
          }
          & img {
            filter: brightness(1000%);
          }
        }
      }
    }

    &-placeholder-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 30px;
      padding-bottom: 30px;
    }

    &__none {
      padding: 0.5rem 1rem;
      font-size: 80%;
      font-style: italic;
    }
  }
}
</style>
